import React from 'react';
import PropTypes from 'prop-types';

/* eslint-disable max-len */
const WavePool = (props) => {
  const { height, width, fill, stroke, className } = props;

  return (
    <svg
      id="wave-pool"
      width={width}
      height={height}
      viewBox="0 0 60 60"
      fill={fill}
      stroke={stroke}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M45.5054 42.2154C48.1159 39.2615 52.3485 39.2615 54.959 42.2154L55 42.2618V47.5209L54.959 47.4992C52.3485 46.1207 48.1159 46.1207 45.5054 47.4992L45.4849 47.51L45.4645 47.5208C42.854 48.8992 38.6214 48.8992 36.0109 47.5208L35.9905 47.51L35.97 47.4992C33.3595 46.1207 29.1269 46.1207 26.5164 47.4992L26.496 47.51L26.4756 47.5208C23.8651 48.8992 19.6325 48.8992 17.022 47.5208L17.0015 47.51L16.9811 47.4992C14.3706 46.1207 10.138 46.1207 7.52749 47.4992L7.50704 47.51L7.48619 47.5209C6.76008 47.9043 5.90732 48.1792 5 48.3493V44.037C5.90732 43.6724 6.76008 43.0834 7.48619 42.2618L7.50704 42.2385L7.52749 42.2154C10.138 39.2615 14.3706 39.2615 16.9811 42.2154L17.0015 42.2385L17.022 42.2616C19.6325 45.2154 23.8651 45.2154 26.4756 42.2616L26.496 42.2385L26.5164 42.2154C29.1269 39.2615 33.3595 39.2615 35.97 42.2154L35.9905 42.2385L36.0109 42.2616C38.6214 45.2154 42.854 45.2154 45.4645 42.2616L45.4849 42.2385L45.5054 42.2154Z"
          fill="#009BB3"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M45.5054 50.5077C48.1159 48.4974 52.3485 48.4974 54.959 50.5077L55 50.5393V52.4965L54.959 52.4658C52.3485 50.5114 48.1159 50.5114 45.5054 52.4658L45.4849 52.4811L45.4645 52.4964C42.854 54.4508 38.6214 54.4508 36.0109 52.4964L35.9905 52.4811L35.97 52.4658C33.3595 50.5114 29.1269 50.5114 26.5164 52.4658L26.496 52.4811L26.4756 52.4964C23.8651 54.4508 19.6325 54.4508 17.022 52.4964L17.0015 52.4811L16.9811 52.4658C14.3706 50.5114 10.138 50.5114 7.52749 52.4658L7.50704 52.4811L7.48619 52.4965C6.76008 53.0401 5.90732 53.4298 5 53.6711V51.7474C5.90732 51.4993 6.76008 51.0984 7.48619 50.5393L7.50704 50.5234L7.52749 50.5077C10.138 48.4974 14.3706 48.4974 16.9811 50.5077L17.0015 50.5234L17.022 50.5392C19.6325 52.5494 23.8651 52.5494 26.4756 50.5392L26.496 50.5234L26.5164 50.5077C29.1269 48.4974 33.3595 48.4974 35.97 50.5077L35.9905 50.5234L36.0109 50.5392C38.6214 52.5494 42.854 52.5494 45.4645 50.5392L45.4849 50.5234L45.5054 50.5077Z"
          fill="#009BB3"
        />
        <path
          d="M18.5 24.3614C12.5 34.7614 5.66667 37.0281 3 36.8614V45.3613H57V34.3613C54.5 35.3613 38.5 40.3613 36.5 28.3613C34.9 18.7613 42.1667 19.6947 46 21.3614C38.5 10.8614 26 11.3614 18.5 24.3614Z"
          fill="#009BB3"
        />
        <path d="M35 17.5C32 16.5 28.5 17.5 26 20.5" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="50" height="55" fill="white" transform="translate(5 3)" />
        </clipPath>
      </defs>
    </svg>
  );
};

WavePool.defaultProps = {
  className: null,
};

WavePool.propTypes = {
  height: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  fill: PropTypes.string.isRequired,
  stroke: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default WavePool;
